import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/common/constants/routes';
import { IMenhirBenefitSlug } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { CardNetworkWidget } from '@/web/components/CardNetworkWidget/CardNetworkWidget';

interface IProps {
  slug: IMenhirBenefitSlug;
}

export const DiscoverCard = ({ slug }: IProps) => {
  const { t } = useTranslation();

  return (
    <CardNetworkWidget
      title={t('dashboard.welfare.card_discover.title')}
      description={t('dashboard.welfare.card_discover.description', {
        slug: t(`dashboard.benefits.links.${slug}`),
      })}
      route={{ pathname: ROUTES.WELFARE_CATEGORIES, params: { slug } }}
    />
  );
};
